export default "__VITE_ASSET__CUZs6EC8__"